"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableMeta = exports.RESERVED_ROOT_NAME = void 0;
const stylable_utils_1 = require("./stylable-utils");
const deprecation_1 = require("./helpers/deprecation");
const features_1 = require("./features");
exports.RESERVED_ROOT_NAME = 'root';
const features = [
    features_1.STSymbol,
    features_1.STImport,
    features_1.STNamespace,
    features_1.STGlobal,
    features_1.STVar,
    features_1.STMixin,
    features_1.CSSClass,
    features_1.CSSType,
    features_1.CSSCustomProperty,
    features_1.CSSKeyframes,
    features_1.CSSLayer,
];
class StylableMeta {
    constructor(ast, diagnostics) {
        this.ast = ast;
        this.diagnostics = diagnostics;
        this.data = {};
        this.rawAst = this.ast.clone();
        this.root = exports.RESERVED_ROOT_NAME;
        this.source = (0, stylable_utils_1.getSourcePath)(this.ast, this.diagnostics);
        this.namespace = '';
        /** @deprecated use meta.getImportStatements() */
        this.imports = [];
        /** @deprecated use meta.getAllStVars() or meta.getStVar(name) */
        this.vars = [];
        /** @deprecated */
        this.cssVars = {};
        /** @deprecated */
        this.keyframes = [];
        /** @deprecated use meta.getAllClasses() or meta.getClass(name) */
        this.classes = {};
        /** @deprecated use meta.getAllTypeElements() or meta.getTypeElement(name) */
        this.elements = {};
        /** @deprecated use meta.getAllSymbols() or meta.getSymbol(name) */
        this.mappedSymbols = {};
        /** @deprecated */
        this.mappedKeyframes = {};
        /** @deprecated */
        this.customSelectors = {};
        this.urls = [];
        this.transformDiagnostics = null;
        this.transformedScopes = null;
        /** @deprecated */
        this.scopes = [];
        /** @deprecated */
        this.mixins = [];
        this.globals = {};
        // initiate features
        const context = { meta: this, diagnostics };
        for (const { hooks } of features) {
            hooks.metaInit(context);
        }
        // set default root
        const rootSymbol = features_1.CSSClass.addClass(context, exports.RESERVED_ROOT_NAME);
        rootSymbol[`-st-root`] = true;
    }
    getSymbol(name) {
        return features_1.STSymbol.get(this, name);
    }
    getAllSymbols() {
        return features_1.STSymbol.getAll(this);
    }
    getClass(name) {
        return features_1.CSSClass.get(this, name);
    }
    getAllClasses() {
        return features_1.CSSClass.getAll(this);
    }
    getTypeElement(name) {
        return features_1.CSSType.get(this, name);
    }
    getAllTypeElements() {
        return features_1.CSSType.getAll(this);
    }
    getImportStatements() {
        return features_1.STImport.getImportStatements(this);
    }
    getStVar(name) {
        return features_1.STSymbol.get(this, name, `var`);
    }
    getAllStVars() {
        return features_1.STSymbol.getAllByType(this, `var`);
    }
}
exports.StylableMeta = StylableMeta;
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `elements`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
    pleaseUse: `meta.getAllTypeElements() or meta.getTypeElement(name)`,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `classes`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
    pleaseUse: `meta.getAllClasses() or meta.getClass(name)`,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `mappedSymbols`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
    pleaseUse: `meta.getAllSymbols() or meta.getSymbol(name)`,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `imports`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
    pleaseUse: `meta.getImportStatements()`,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `keyframes`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `mappedKeyframes`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `cssVars`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `vars`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
    pleaseUse: `meta.getAllStVars() or meta.getStVar(name)`,
});
(0, deprecation_1.setFieldForDeprecation)(StylableMeta.prototype, `mixins`, {
    objectType: `stylableMeta`,
    valueOnThis: true,
});
//# sourceMappingURL=stylable-meta.js.map